import type { MessageDescriptor } from 'react-intl';
import { defineMessages } from 'react-intl';

export const recentWorkMessages: Record<string, MessageDescriptor> = defineMessages({
	contentUntitled: {
		id: 'entity-view.recent-work.content-untitled',
		defaultMessage: 'Untitled',
		description: 'Fallback title for an untitled recent content item.',
	},
	contentTypePage: {
		id: 'entity-view.recent-work.content-type.page',
		defaultMessage: 'Page',
		description: 'Content type label for a page in the recent work list.',
	},
	contentTypeLiveDoc: {
		id: 'entity-view.recent-work.content-type.live-doc',
		defaultMessage: 'Live doc',
		description: 'Content type label for a live doc in the recent work list.',
	},
	contentTypeBlogPost: {
		id: 'entity-view.recent-work.content-type.blog-post',
		defaultMessage: 'Blog post',
		description: 'Content type label for a blog post in the recent work list.',
	},
	contentTypeWhiteboard: {
		id: 'entity-view.recent-work.content-type.whiteboard',
		defaultMessage: 'Whiteboard',
		description: 'Content type label for a whiteboard in the recent work list.',
	},
	contentTypeDatabase: {
		id: 'entity-view.recent-work.content-type.database',
		defaultMessage: 'Database',
		description: 'Content type label for a database in the recent work list.',
	},
	contentTypeSmartLink: {
		id: 'entity-view.recent-work.content-type.smart-link',
		defaultMessage: 'Smart Link',
		description: 'Content type label for an embedded Smart Link in the recent work list.',
	},
	contentTypeSlide: {
		id: 'entity-view.recent-work.content-type.slide',
		defaultMessage: 'Slide',
		description: 'Content type label for a slide in the recent work list.',
	},
});
